<template>
  <div style="margin-right: 10px" class="login-success" ref="loginSuccess">
    <a-popover
      v-model="visible"
      placement="bottomRight"
      overlayClassName="avatar-popover-overlay"
      :trigger="['hover']"
      :getPopupContainer="() => $refs.loginSuccess"
    >
      <template slot="content">
        <!-- <div style="min-width:200px; padding:18px 12px; display:flex; align-items:center;" :style="note">
          <div v-if="hideInfo" style="margin-right:10px;border-radius:50%; width:32px; height:32px; font-size:20px; text-align:center; overflow: hidden;" :style="{background: !hideInfo.headImgUrl ? '#d1d1d1' : '#fff'}">
            <icon-font class="open-icon-user" type="open-icon-user" style="color: #aaa;" v-if="!hideInfo.headImgUrl" />
            <img :src="hideInfo.headImgUrl" style="width:32px; height: 32px; display:block" v-else >
          </div>
          <div style="flex:1;min-width:0; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
            {{ hideInfo.onlineSubjectName }}
          </div>
        </div> -->
        <!-- menu -->
        <a-menu
          mode="vertical"
          :selectable="false"
          @click="handleMenuClick"
        >
          <!-- 切换企业 -->
          <a-menu-item key="switch">
            <icon-font type="open-icon-daohang-fucengtubiao-qiehuanqiye"  />
            <div>{{ $t('common_btn_switch_comp') }}</div>
            <icon-font type="open-icon-shouye-tubiao-gengduo" class="anticon-right" />
          </a-menu-item>
          <!-- 退出 -->
          <a-menu-item key="logout">
            <icon-font type="open-icon-daohang-fucengtubiao-tuichu"  />
            <div>{{ $t('common_btn_login_out') }}</div>
          </a-menu-item>
        </a-menu>
      </template>
      <div class="right-content__action">
        <icon-font class="open-icon-user" type="open-icon-user" v-if="!hideInfo.headImgUrl"  />
        <img :src="hideInfo.headImgUrl" style="width:22px; height: 22px; border-radius: 50%; background: #fff" v-else >
        <span class="login-text">{{ hideInfo.onlineSubjectName }}</span>
        <span class="login-icon"></span>
      </div>
      <switch-company ref="switchCompany"></switch-company>
    </a-popover>
  </div>
</template>

<script>
import { ACCESS_TOKEN, ACCESS_SUNID } from '@/store/mutation-types'
import SwitchCompany from '@/components/SwitchCompany'
// import { openNotificationWithIcon } from '@/utils/util'
import { SsoLogout } from '@/api/login'
import { mapGetters } from 'vuex'

export default {
  name: 'HeadCompanyShow',
  components: {
    SwitchCompany
  },
  data () {
    return {
      note: {
        background: 'linear-gradient(239deg, #D5DEEE 0%, #E3ECF7 100%)'
      },
      visible: false
    }
  },
  computed: {
    ...mapGetters([
      'hideInfo'
    ])
  },
  methods: {
    handleMenuClick ({ key: action }) {
      this[action]()
    },
    switch () {
      if (this.$store.state.isLogin.isChoiceSubject === true) {
        this.$store.commit('SET_IS_CHOICE_SUBJECT', false)
        // this.$store.commit('SET_IS_CHOICE_SUBJECT', true)
      } else {
        this.$store.commit('SET_IS_CHOICE_SUBJECT', true)
      }
    },
    logout () {
      this.$confirm({
        title: this.$t('common_globalcomp_exit_login_title'),
        content: this.$t('common_globalcomp_exit_login_info'),
        okType: 'danger',
        okText: this.$t('common_btn_confirm'),
        cancelText: this.$t('common_btn_cancel'),
        onOk: () => {
          setTimeout(() => {
            SsoLogout().finally(() => {
              this.$ls.remove(ACCESS_TOKEN)
              this.$ls.remove(ACCESS_SUNID)
              this.$store.commit('SET_SUBJECT_ID', '') // 退出清空subjectId
              this.$store.commit('USER_INFO', {}) // 退出清空userInfo
              this.$store.commit('SET_LEFT_MENU') // 退出清空工作台菜单
              this.$router.push({ path: '/home' })
              setTimeout(() => {
                location.reload()
              })
            })
          }, 100)
        }
      })
    }
  }
}
</script>

<style lang="less">
.avatar-popover-overlay {
  margin-right: 10px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  .ant-popover-arrow {
    top: -7px !important;
    border-top-color: #fff !important;
    border-left-color: #fff !important;
  }
  .ant-popover-inner {
    margin-top: -14px;
  }
  .ant-popover-inner-content {
    padding: 0;
    width: 180px;
    position: relative;
    font-size: 14px;
    .ant-menu-item, .ant-menu-submenu {
      display: flex;
      margin: 0 !important;
      align-items: center;
      height: 46px !important;
      line-height: 1;
      .anticon {
        color: rgba(0, 0, 0, 0.65);
        font-size: 16px;
      }
      .anticon-right {
        margin-left: auto;
        margin-right: 0;
        color: rgba(0, 0, 0, 0.25);
        font-size: 12px;
      }
    }
    .ant-menu-item:hover {
      background: #F0F7FF;
      .anticon {
        color: #077BFC;
      }
    }
  }
  .ant-menu-submenu-arrow {
    display: none;
  }
  .ant-menu-sub:hover {
    .ant-menu-item {
      background: transparent !important;
    }
  }
}

</style>

<style lang="less" scoped>
.login-success {
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
}
.right-content__action {
  height: 64px;
  position: relative;
  padding: 0px 12px;
  max-width: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  .login-text {
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
    display: inline-block;
    min-width: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 25px;
    position: relative;
  }
  .login-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-2px);
    width: 0;
    height: 0;
    border: 4px solid transparent;
    border-top: 6px solid #FFFFFF;
  }
}
</style>
